var map = {
	"./promotion-basic.svg": "2a4e",
	"./promotion-boost-plus.svg": "d358",
	"./promotion-boost-pro.svg": "815f",
	"./promotion-boost.svg": "117c",
	"./promotion-check-mark.svg": "24c3",
	"./promotion-no.svg": "86ad",
	"./promotion-tooltip.svg": "20b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5913";